import React from "react";
import {useState, useContext} from "react";
import config from "../../js/config_static";

import { Navigate } from 'react-router-dom';

import "../../ui/css/general.css";
import "./GreetingWindow.css";
import "./Login.css";

import api from "../../js/utils/async/api";

import CredentialsContext from "../contexts/CredentialsContext";

export default function Login(props) {
  const redirect = props.redirect || "/logout";

  const {credentials, setCredentials} = useContext(CredentialsContext);


  const [username, setUserName] = useState();
  const [password, setPassword] = useState();

  const [loginError, setLoginError] = useState();

  const handleSubmit = async e => {
    e.preventDefault();
    const userCredentials = {
      name: username,
      password
    }
    try {
      const result = await api.users.login(userCredentials);
      if (result.name) {
        setCredentials(result);
      }
      else 
        throw new Error()
    } catch (error) {
      setLoginError("Ошибка авторизации");
    }
  }

  if (credentials) {
    return <Navigate to={redirect} /> 
  }
   
  return <div className="centering">
    <h1>Добро пожаловать в сервис закрытого тестирования программных продуктов</h1>
    <h1>группы компаний «ЮрИнФоР»</h1>
    <div className="loginpanel">
        <div className="title">{config.ui.Login.title}</div>
        {loginError && <div style={{color: "red", textAlign: "center"}}>{loginError}</div>}
        <form id="login" onSubmit={handleSubmit}>
            <label htmlFor="username">{config.ui.Login.login}</label><br/>
            <input type="text" id="username" name="username" className="form-control"
                onChange={e => setUserName(e.target.value)}>  
            </input>
            <br/>
            <label htmlFor="username">{config.ui.Login.password}</label><br/>
            <input type="password" id="password" name="password" className="form-control"
                onChange={e => setPassword(e.target.value)}>
            </input>
            <br/>
            <div className="centering">
                <input type="submit" className="btn btn-success" defaultValue={config.ui.Login.title}></input>
            </div>
        </form>
    </div>
  </div>
}
